<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="white-card">
        <div class="header-title-row">
          <div class="header-left">
            <img
              src="assets/svg/forecast-icon.svg"
              alt="Prospectos"
              class="center-svg"
            />
            <h1 class="text-semibold color-org t-24">Forecast</h1>
            <div class="dropdown-wrapper" #dropdownContainer>
              <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                <span>
                  {{selectedItem === 'todos' ? 'Ver todos' : selectedItem ===
                  'propios' ? 'Ver propios' : 'ver todos los pronósticos' }}
                </span>
                <span [class.rotated]="showRecentDropdown">▼</span>
                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem === 'todos'"
                    (click)="selectItem('todos'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem === 'todos'"
                      >✔</span
                    >Ver todos
                  </button>
                  <button
                    class="dropdown-item"
                    [class.selected]="selectedItem === 'propios'"
                    (click)="selectItem('propios'); $event.stopPropagation()"
                  >
                    <span class="check-icon" *ngIf="selectedItem === 'propios'"
                      >✔</span
                    >
                    Ver propios
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="header-actions">
              <button class="btn btn-round-outline" >
                <img class="center-svg" src="assets/svg/reload-icon-org.svg" />
              </button>
              <button class="btn btn-round-outline" >
                <img class="center-svg" src="assets/svg/settings-icon.svg" />
              </button>
            
                        <button class="action-btn outline">
                            <img src="assets/svg/plus-orange.svg" alt="Vista resumen" width="16" height="16" />
                            Descargar pronostico
                        </button>

            <button class="action-btn primary" (click)="showGraphicView()">
              <img
                src="assets/svg/stast-white.svg"
                alt="Ver grafico"
                width="16"
                height="16"
              />
                Ver graficos
            </button>
          </div>
        </div>

        <div
          class="header-stats mt-3"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div class="header-stats mt-3">
            <span>Última actualización 9/10/2025 a las 14:45</span>
          </div>
        </div>
        <div class="content-area mt-5">
          <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
          <div *ngIf="!isLoading && forecasts.length > 0">
        </div>

<div class="forecast prospectos-table mh-50">
  <table>
    <thead>
      <tr class="header-forecast">
        <th>Meses</th>
        <th>Metas</th>
        <th>Oportunidades cerradas</th>
        <th>Mejor de los casos</th>
        <th>Oportunidades de baja probabilidad</th>
        <th>Total pipeline</th>
      </tr>
    </thead>

    <tbody>
      <tr class="totales-row">
        <td>Total: 12 meses</td>
        <td>CLP {{ totales.total_metas | number:'1.0-0' }}</td>
        <td>CLP {{ totales.cerradas_ganadas | number:'1.0-0' }}</td>
        <td>CLP {{ totales.alta_probabilidad | number:'1.0-0' }}</td>
        <td>CLP {{ totales.baja_probabilidad | number:'1.0-0' }}</td>
        <td>CLP {{ totales.total_pipeline | number:'1.0-0' }}</td>
      </tr>

      <ng-container *ngFor="let forecast of forecasts">
        <tr (click)="toggleMonth(forecast.mes)" class="month-row">
          <td>
            <span class="color-org d-flex d-inline-flex align-center" style="gap:8px">
              <img
                src="assets/svg/arrow-down.svg"
                [class.rotated]="expandedMonth === forecast.mes"
                width="12"
                alt="toggle"
                class="arrow-icon"
              />
              {{ forecast.mes_largo }} de año fiscal
              <span *ngIf="forecast.actual" class="badge">Mes actual</span>
            </span>
          </td>

          <td>CLP {{ forecast.total_metas | number:'1.0-0' }}</td>
          <td>CLP {{ forecast.cerradas_ganadas | number:'1.0-0' }}</td>
          <td>CLP {{ forecast.alta_probabilidad | number:'1.0-0' }}</td>
          <td>CLP {{ forecast.baja_probabilidad | number:'1.0-0' }}</td>
          <td>CLP {{ forecast.total_pipeline | number:'1.0-0' }}</td>
        </tr>

        <tr
          *ngFor="let e of forecast.detalle"
          [class.show]="expandedMonth === forecast.mes"
          class="executive-row"
          (click)="showExecutiveDetails(e)"
        >
          <td class="d-flex d-inline-flex gap-10">
            <img src="assets/svg/user-icon-2.svg" width="16" />
            {{ e.ejecutivo }}
          </td>
          <td>CLP {{ e.total_metas | number:'1.0-0' }}</td>
          <td>CLP {{ e.cerradas_ganadas | number:'1.0-0' }}</td>
          <td>CLP {{ e.alta_probabilidad | number:'1.0-0' }}</td>
          <td>CLP {{ e.baja_probabilidad | number:'1.0-0' }}</td>
          <td>CLP {{ e.total_pipeline | number:'1.0-0' }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<div *ngIf="selectedExecutive" class="detail-section mt-4">
    <div class="d-grid search-bar-container" style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      gap: 16px;">
    <div class="search-bar d-flex align-center" style="font-size: 12px;">Mostrando oportunidades de todos los prónosticos | Octubre 2025(Año fiscal) | Todas las categorías</div>
  </div>

  <div class="prospectos-table mh-50 forecast-table">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Nombre de la oportunidad</th>
          <th>Nombre de la cuenta</th>
          <th>Importe</th>
          <th>Fecha de cierre</th>
          <th>Etapa</th>
          <th>Probabilidad</th>
          <th>Categoría de previsión</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let opp of selectedOpportunities; index as i">
          <td>{{ i + 1 }}</td>
          <td class="color-org">{{ opp.nombre }}</td>
          <td class="color-org">{{ opp.cuenta.nombre_empresa }}</td>
          <td>CLP {{ opp.importe_actual | number:'1.0-0' }}</td>
          <td>{{ opp.fecha_cierre_estimada }}</td>
          <td>{{ opp.estado.nombre }}</td>
          <td>{{ opp.probabilidad_cierre | number:'1.0-0'}} %</td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>


          </div>
          <div
            *ngIf="!isLoading && forecasts.length === 0 && !errorMessage"
            class="empty-state"
          >
            <div class="empty-content">
              <div class="empty-image">
                <img
                  src="assets/img/listaprospecto.png"
                  alt="Lista de prospectos vacía"
                />
              </div>
              <h2>Sin tareas por ahora</h2>
              <p>
                Todavía no tienes tareas registrados. Puedes comenzar agregando
                una nueva.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
